import React from "react";
import { TableContainerProps } from "./types";

export const TableContainer: React.FC<TableContainerProps> = ({
  children,
  loading = false,
  loadingText = "Loading...",
  isEmpty = false,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  title,
  titleIcon,
  count,
  headerAction,
  className = "",
}) => {
  return (
    <div
      className={`rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ${className}`}
    >
      {title && (
        <div className="px-5 py-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-title-sm font-semibold text-black dark:text-white">
            {titleIcon}
            {title}
            {count !== undefined && (
              <span className="text-sm font-normal text-gray-600 dark:text-gray-400">
                ({count})
              </span>
            )}
          </h2>
          {headerAction}
        </div>
      )}

      {loading ? (
        <div className="py-12 text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-brand-600 border-t-transparent"></div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {loadingText}
          </p>
        </div>
      ) : isEmpty ? (
        <div className="py-12 text-center">
          {emptyIcon && (
            <div className="mx-auto mb-4 flex items-center justify-center opacity-30 text-gray-400">
              {emptyIcon}
            </div>
          )}
          {emptyTitle && (
            <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
              {emptyTitle}
            </p>
          )}
          {emptyDescription && (
            <p className="mb-4 text-sm text-gray-500 dark:text-gray-500">
              {emptyDescription}
            </p>
          )}
          {emptyAction && (
            <button
              onClick={emptyAction.onClick}
              className="inline-flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
            >
              {emptyAction.icon}
              {emptyAction.label}
            </button>
          )}
        </div>
      ) : (
        children
      )}
    </div>
  );
};
